
import wx from 'weixin-js-sdk'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'


export default {
name: 'curtainAddGoods',
components: {
wx,PopupPicker,CheckIcon,XTextarea,Group,Datetime
},
data() {
return {
datetimeStatus:false,
startDate:'',
minHour:6,
maxHour:24,
minuteList:['00','30'],
address:'',
goods:[],
fromIndex:1,
froms:[
{
key:1,
title:'小程序'
},
{
key:2,
title:'抖音'
},
{
key:3,
title:'其他'
},
],
typeIndex:0,
types:[
{
key:1,
title:'上门拆装清洗'
},
{
key:2,
title:'只清洗不拆装'
},
],
formData:{
id:0,
goods_id:0,
goods_title:'',
order_no:'',
name:'',
phone:'',
province:'陕西省',
city:'西安市',
district:'',
address:'',
lat:'',
lng:'',
source:2,
type:1,
pay_status:0,
home_time:'请选择',
content:'',
},
}
},
created() {
this.formData.id = Number(this.$route.params.id);
if(this.formData.id > 0){
this.getCurtainOrder();
}
this.getCurtainGoods();
this.config();
this.setDate();
},
computed:{

},
beforeRouteLeave(to, from, next) {
if(to.name == 'maps'){
from.meta.keepAlive = true;
}else{
var key = this.$vnode.key == null ? this.$vnode.componentOptions.Ctor.cid + (this.$vnode.componentOptions.tag ? `::${this.$vnode.componentOptions.tag}` : '') : this.$vnode.key
var cache = this.$vnode.parent.componentInstance.cache
var keys = this.$vnode.parent.componentInstance.keys
console.log(key,cache,keys);
if (cache[key]) {
if (keys.length) {
var index = keys.indexOf(key)
if (index > -1) {
keys.splice(index, 1)
}
}
delete cache[key]
}
}
next();
},
activated(){
if(this.$func.getSession('address')){
let address = JSON.parse(this.$func.getSession('address'));
this.formData.address = address.poiaddress;

this.formData.lat = address.latlng.lat;
this.formData.lng = address.latlng.lng;
this.$func.setSession('address','');
}
},
methods: {
getCurtainOrder(){
this.$api.getCurtainOrderInfo({id:this.formData.id}).then((res)=>{
if(res){
this.formData = res.data;
this.fromIndex = this.formData.source - 1;
this.typeIndex = this.formData.type-1;
this.goodsIndex = this.formData.goods_id-1;
}
})
},
setDate() {
var nowDate = new Date();
var date = {
year: nowDate.getFullYear(),
month: nowDate.getMonth() + 1,
day: nowDate.getDate(),

}
this.startDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);











},
datetimeChange(val){
this.formData.home_time = val;
this.datetimeStatus = false;
},
recognizeAddress(){
const info = this.parseAddress(this.address);
this.formData.name = info.name || '';
this.formData.phone = info.phone || '';
this.formData.address = info.address || '';
this.formData.province = info.province || '';
this.formData.city = info.city || '';
this.formData.district = info.district || '';
},
parseAddress(text){
let src = (text || '').trim();
if(!src){
return { name:'', phone:'', address:'', province:'', city:'', district:'' };
}

src = src.replace(/[\t\r\n]+/g, ' ').replace(/[，,；;]+/g, ' ').replace(/\s{2,}/g, ' ').trim();


let phone = '';
const mobileMatch = src.match(/(1[3-9]\d{9})/);
if(mobileMatch){
phone = mobileMatch[1];
} else {
const landlineMatch = src.match(/((?:0\d{2,3}-?)\d{7,8})/);
if(landlineMatch){
phone = landlineMatch[1];
}
}


let name = '';
const nameByKey = src.match(/(?:收件人|联系人|姓名)[：:\s]*([\u4e00-\u9fa5·]{2,15})/);
if(nameByKey){
name = nameByKey[1];
} else if(phone){
const beforePhone = src.split(phone)[0];
const nearName = beforePhone.match(/([\u4e00-\u9fa5·]{2,15})\s*$/);
if(nearName){
name = nearName[1];
} else {
const startName = src.match(/^([\u4e00-\u9fa5·]{2,15})\b/);
if(startName){ name = startName[1]; }
}
} else {
const startName = src.match(/^([\u4e00-\u9fa5·]{2,15})\b/);
if(startName){ name = startName[1]; }
}


let address = src;
if(phone){ address = address.replace(phone, ''); }
if(name){ address = address.replace(name, ''); }
address = address.replace(/(收件人|联系人|姓名|地址|详细地址|上门地址)[：:\s]*/g, '')
.replace(/\s{2,}/g, ' ').trim();


let province = '';
let city = '';
let district = '';


const provRegex = /([\u4e00-\u9fa5]+?(?:省|自治区|特别行政区)|(?:北京|上海|天津|重庆)市|香港特别行政区|澳门特别行政区)/;
const provMatch = address.match(provRegex);
if(provMatch){
province = provMatch[1];
address = address.replace(province, '').trim();
}


const cityRegex = /([\u4e00-\u9fa5]+?(?:市|地区|盟))/;
const cityMatch = address.match(cityRegex);
if(cityMatch){
city = cityMatch[1];
address = address.replace(city, '').trim();
} else if(!province){

const muniStart = address.match(/^(北京|上海|天津|重庆)/);
if(muniStart){
city = muniStart[1] + '市';
address = address.replace(muniStart[1], '').trim();
}
}


const distRegex = /([\u4e00-\u9fa5]+?(?:区|县|旗|市))/;
const distMatch = address.match(distRegex);
if(distMatch){
district = distMatch[1];
address = address.replace(district, '').trim();
}

return { name, phone, address, province, city, district };
},
getCurtainGoods() {
this.$api.getCurtainGoods({}).then((res)=>{
if(res){
this.goods = res.data;
if(!this.formData.id){
this.formData.goods_id = this.goods[0].id;
this.formData.goods_title = this.goods[0].title;
}
}
})
},
cateGoods(index){
this.formData.goods_id = this.goods[index].id;
this.formData.goods_title = this.goods[index].title;
},
cateFrom(index){
this.fromIndex = index;
this.formData.source = this.froms[index].key;
},
cateType(index){
this.typeIndex = index;
this.formData.type = this.types[index].key;
},
position(){
let that = this;
wx.getLocation({
type: 'gcj02',
success: function (res) {
console.log('getLocation',res);
that.$router.push({name:'maps',params:{latitude:res.latitude,longitude:res.longitude}})
}
});
},
submit() {
if(!this.formData.goods_id){
this.$func.showToast('请选择产品');
return false;
}
if(!this.formData.name){
this.$func.showToast('请输入联系人');
return false;
}
if(!this.formData.phone){
this.$func.showToast('请输入联系人手机号');
return false;
}
if(!this.formData.address){
this.$func.showToast('请输入上门地址');
return false;
}




if(this.formData.home_time == '请选择'){
this.formData.home_time = '';
}
this.$func.confirm('确认提交订单？','提示',()=>{
this.$func.startLoading('请求中。。。');
this.$api.submitCurtainOrder(this.formData).then((res)=>{
this.$func.endLoading();
this.$func.showToast('提交成功');
if(this.formData.id > 0){
setTimeout(()=>{
this.$router.go(-1);
},300)
}else{
setTimeout(()=>{
window.location.reload();
},300)
}
});
})
},
config(){
let url = (window.location.href).split('#');
if(url[0].indexOf('?') != '-1'){
url = url[0].split('?');
}
this.$api.wxSign({url:url[0]}).then((res)=>{
if(res){
wx.config({
debug: false, //调试阶段建议开启
appId: res.data.appId,
timestamp: res.data.timestamp,
nonceStr: res.data.nonceStr,
signature:res.data.signature,
jsApiList: [
"getLocation",
]
});
}
})
},
}
,watch:{
address(newVal){
clearTimeout(this._addrTimer);
this._addrTimer = setTimeout(()=>{
this.recognizeAddress();
},300);
}
}
}



// WEBPACK FOOTER //
// ./src/pages/createCurtainOrder.vue